import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { YMInitializer } from "react-yandex-metrika";
import "./style.css";

import { applyLangClass, store } from "./_helpers";
import { SnackbarProvider } from './_services/snackbarService';

import "./i18n";

const ym_id = process.env.REACT_APP_YM_ID;

const CARD_MODE = process.env.REACT_APP_CARD_MODE === "true";
const CHINA_MODE = process.env.REACT_APP_CHINA_MODE === "true";

// Литерал process.env обязателен именно здесь, и именно в if, а не в тернарнике
// и не через константу CARD_MODE: только так webpack сворачивает ветку до `if (false)`
// и выбрасывает require("./App") вместе со всем графом кабинета организатора.
// Через промежуточную const или import из _constants мёртвая ветка остаётся в бандле.
let RootApp;
if (process.env.REACT_APP_CARD_MODE === "true") {
  // Системную локаль и версию приложения обёртка передаёт query-параметрами первой
  // загрузки, а SPA-навигация их теряет — раскладываем в localStorage до первого
  // рендера, потому что публичные страницы читают navic_lang прямо при рендере.
  require("./CardApp/nativeBridge").captureBootParams();
  // До первого рендера, а не в componentDidMount корня: дети монтируются раньше
  // родителя, и их запросы axios успевали собрать цепочку без перехватчика —
  // 401 на стартовой загрузке «Контактов» проходил мимо него.
  require("./CardApp/session").installUnauthorizedInterceptor();
  RootApp = require("./CardApp/CardApp").CardApp;
} else {
  RootApp = require("./App").App;
}

// lang-класс на body нужен до первого рендера: часть страниц не зовёт initLanguage
applyLangClass();

if (CHINA_MODE) {
  // Возврат в китайское приложение из браузерных цепочек (оплата, сброс пароля).
  // В режиме «визитка» этого делать нельзя: страница отдаётся с http://localhost:8080.
  const isMobile = /Android|iPhone/i.test(navigator.userAgent);
  if (isMobile && window.location.protocol === 'https:') {
    window.location.href = window.location.href.replace("https://", "naviconf://");
  }
}

// Чат с оператором — везде, кроме «визитки» и китайской сборки (как раньше Jivo):
// доступность сервера чата из Китая не решена. Литералы process.env и require внутри if —
// по той же причине, что у RootApp выше: иначе загрузчик остаётся в мобильной сборке.
if (process.env.REACT_APP_CARD_MODE !== "true" && process.env.REACT_APP_CHINA_MODE !== "true") {
  require("./_helpers/lhcWidget").initLhcWidget();
}

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
}

ReactDOM.render(
  <Provider store={store}>
    {process.env.REACT_APP_CHINA_MODE === "false" && !CARD_MODE &&
      <YMInitializer
        accounts={[ym_id]}
        options={{ webvisor: true }}
        version="2"
      />
    }
    <SnackbarProvider>
      <RootApp />
    </SnackbarProvider>
  </Provider>,
  document.getElementById("root")
);

